import { useEffect, useState, useContext } from "react";
import axios from "axios";
import GuruLayout from "../../components/layout/GuruLayout";
import { AuthContext } from "../../context/AuthContext";

const API = "https://backend.smpn1kamal.sch.id/api";

export default function MonitoringPresensi() {
  const { token } = useContext(AuthContext);

  const [kelasList, setKelasList] = useState([]);
  const [mapelList, setMapelList] = useState([]);

  const [idKelas, setIdKelas] = useState("");
  const [idMapel, setIdMapel] = useState("");
  const [search, setSearch] = useState("");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= LOAD DROPDOWN ================= */
  useEffect(() => {
    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };

    axios.get(`${API}/kelas`, { headers })
      .then(res => setKelasList(res.data))
      .catch(() => console.log("Gagal load kelas"));

    axios.get(`${API}/datamapel`, { headers })
      .then(res => setMapelList(res.data))
      .catch(() => console.log("Gagal load mapel"));
  }, [token]);

  /* ================= LOAD DATA ================= */
  useEffect(() => {
    if (!idKelas || !idMapel || !token) return;

    const headers = { Authorization: `Bearer ${token}` };

    setLoading(true);

    axios.get(`${API}/monitoring/${idKelas}/${idMapel}`, { headers })
      .then(res => setData(res.data))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [idKelas, idMapel, token]);

  /* ================= UPDATE STATUS ================= */
  const handleChangeStatus = async (id_siswa, status) => {
    try {
      await axios.put(
        `${API}/monitoring/status`,
        { id_siswa, status },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setData(prev =>
        prev.map(item =>
          item.id === id_siswa ? { ...item, status } : item
        )
      );
    } catch {
      alert("Gagal update status");
    }
  };

  /* ================= STYLE STATUS ================= */
  const getStatusStyle = (status) => {
    switch (status) {
      case "hadir":
        return "bg-green-100 text-green-600 border-green-200";
      case "izin":
        return "bg-yellow-100 text-yellow-600 border-yellow-200";
      case "sakit":
        return "bg-blue-100 text-blue-600 border-blue-200";
      case "alfa":
        return "bg-red-100 text-red-600 border-red-200";
      default:
        return "bg-slate-100 text-slate-600";
    }
  };

  const filteredData = data.filter((item) =>
    item.nama_lengkap.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <GuruLayout>
      <div className="space-y-6">

        {/* ===== TITLE ===== */}
        <div>
          <h1 className="text-2xl font-bold text-blue-600">
            Monitoring Kehadiran
          </h1>
          <p className="text-sm text-slate-500">Hari Ini</p>
        </div>

        {/* ===== CARD ===== */}
        <div className="bg-white rounded-xl shadow p-6 space-y-6">

          {/* ===== FILTER ===== */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <select
              value={idKelas}
              onChange={(e) => setIdKelas(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500"
            >
              <option value="">Pilih kelas</option>
              {kelasList.map(k => (
                <option key={k.id_kelas} value={k.id_kelas}>
                  {k.nama_kelas}
                </option>
              ))}
            </select>

            <select
              value={idMapel}
              onChange={(e) => setIdMapel(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500"
            >
              <option value="">Mapel</option>
              {mapelList.map(m => (
                <option key={m.id_mapel} value={m.id_mapel}>
                  {m.nama_mapel}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Search siswa..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500"
            />
          </div>

          {/* ================= DESKTOP TABLE ================= */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-600">
                <tr>
                  <th className="px-4 py-3 text-left">NO ABSEN</th>
                  <th className="px-4 py-3 text-left">NAMA SISWA</th>
                  <th className="px-4 py-3 text-left">KETERANGAN</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center py-6">
                      Loading...
                    </td>
                  </tr>
                ) : filteredData.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center py-6 text-slate-500">
                      Data tidak ditemukan
                    </td>
                  </tr>
                ) : (
                  filteredData.map((item) => (
                    <tr key={item.id} className="border-t hover:bg-slate-50">
                      <td className="px-4 py-3">{item.no_absen}</td>
                      <td className="px-4 py-3">{item.nama_lengkap}</td>
                      <td className="px-4 py-3">
                        <select
                          value={item.status}
                          onChange={(e) =>
                            handleChangeStatus(item.id, e.target.value)
                          }
                          className={`px-3 py-1 rounded-full text-xs font-medium border outline-none ${getStatusStyle(item.status)}`}
                        >
                          <option value="hadir">Hadir</option>
                          <option value="izin">Izin</option>
                          <option value="sakit">Sakit</option>
                          <option value="alfa">Alfa</option>
                        </select>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ================= MOBILE CARD ================= */}
          <div className="md:hidden space-y-4">
            {filteredData.map((item) => (
              <div
                key={item.id}
                className="border rounded-xl p-4 hover:bg-slate-50 transition"
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-slate-800">
                    {item.nama_lengkap}
                  </span>

                  <select
                    value={item.status}
                    onChange={(e) =>
                      handleChangeStatus(item.id, e.target.value)
                    }
                    className={`px-3 py-1 rounded-full text-xs font-medium border outline-none ${getStatusStyle(item.status)}`}
                  >
                    <option value="hadir">Hadir</option>
                    <option value="izin">Izin</option>
                    <option value="sakit">Sakit</option>
                    <option value="alfa">Alfa</option>
                  </select>
                </div>

                <p className="text-sm text-slate-600">
                  Absen: {item.no_absen}
                </p>
              </div>
            ))}

            {!loading && filteredData.length === 0 && (
              <p className="text-center text-slate-500">
                Data tidak ditemukan
              </p>
            )}
          </div>

        </div>
      </div>
    </GuruLayout>
  );
}